/* eslint-disable no-empty */
/* eslint-disable no-unused-vars */
const viewFormData = (formData) => {
  for (var key of formData.entries()) {
  }
  return
}
export default viewFormData
